var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CBadge',{attrs:{"rounded":_vm.rounded,"bg-class":"tw-bg-red-100","text-class":"tw-text-red-800","size":_vm.size}},[_vm._v("\n  "+_vm._s(_vm.$t('wanted::classified'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }